import {CommonAppState} from '../../commonAppState';

export function getTimeFormat(state: CommonAppState) {
  return state.data.preferences.timeFormat;
}

export function getUserTimeZone(state: CommonAppState) {
  return state.data.preferences.timezone.timezone;
}

export function getShouldUpdateTimeZoneAutomatically(state: CommonAppState) {
  return state.data.preferences.timezone.shouldUpdateAutomatically;
}

export function getTimezonePreferences(state: CommonAppState) {
  return state.data.preferences.timezone;
}

export function getTheme(state: CommonAppState) {
  return state.data.preferences.userTheme;
}

export function getHasInboxImprovementsTogglePreferenceEnabled(state: CommonAppState) {
  return state.data.preferences.hasInboxImprovementsTogglePreferenceEnabled ?? false;
}
